import React, { useEffect } from 'react';
import { Util, Request, Principal, Scroller, StateProvider, ProxyProvider, childrenText, BAProvider } from '../common';
import { InputAdornment, CircularProgress, IconButton, FormControl, InputLabel, FormHelperText } from '@material-ui/core';
import { Scrollbars } from 'react-custom-scrollbars';
import { Alert } from 'reactstrap';
import Base64 from 'base-64';
import ReactDOM from 'react-dom';
import {
  KeepAlive, useKeepAliveEffect, bindLifecycle
} from 'codeArt/keep';
import App from 'codeArt/external/containers/App';
import { SpringSystem, MathUtil } from 'rebound';
import Backdrop, { LoadingSlim } from './Backdrop';
import { Tracker } from 'codeArt/track';
import { getConfig } from 'codeArt/external/containers/Apps';
import { makeStyles } from '@material-ui/core/styles';
import { Tester } from 'codeArt/test';

export function combineEvent(c0, c1) { //c0,c1是用于响应事件的函数
  if (c0 && !c1) return c0;
  if (!c0 && c1) return c1;
  if (!c0 && !c1) return null;
  return function () { //这里不能用()=> 因为会将arguments记录为c0,c1
    var args = arguments;
    c0.apply(this, args);
    c1.apply(this, args);
  }
}

let _cluster = {};

export function mapClusterKey(key) {
  if (!key) return key;
  // let path = window.location.pathname;
  // return `${path}-${key}`;  //通过地址来追加
  return Page.current ? Page.current.getCluster(key) : key;
}

function createCluster(o, key, func) {
  var c = _cluster[key];
  if (c) {
    if (c.master) throw new Error(`已存在${key}的组件集群`); //已存在的集群都有master了，那证明重复创建
    c.master = o;
    c.func = func;
    return c;
  }
  else {
    _cluster[key] = { func, master: o, slaves: [] };  //func表示集群的功能
    return _cluster[key];
  }
}

function removeCluster(key) {
  delete _cluster[key];
}

function addSlave(o, key) {
  var c = getCluster(key);
  if (!c) {
    c = createCluster(null, key, null);  //有可能在页面布局中，salve组件先创建，集群所在的mater组件后创建的，所以需要先创建一个不含master的集群
  }
  c.slaves.push(o);
}

function removeSlave(o, key) {
  var c = getCluster(key);
  if (!c) return;  //有可能集群已被移除，所以不需要再移除slave
  Util.remove(c.slaves, (t) => t == o);
}

function getCluster(key) {
  return _cluster[key];
}

export let Cluster = {
  openMaster(o) {
    let master = o.master;
    if (!master) return;

    if (Util.type(master) == "object") {  //{功能:集群格式}
      master = [master];
    }

    master.forEach((c) => {
      var func = Object.keys(c)[0];  //{key:value} key是功能名，value是集群的名称
      var key = c[func];
      createCluster(o, key, func);
    });
  },
  closeMaster(o) {
    let master = o.master;
    if (!master) return;

    if (Util.type(master) == "object") {  //{功能:集群格式}
      master = [master];
    }

    master.forEach((c) => {
      var func = Object.keys(c)[0];
      var key = c[func];
      removeCluster(key);
    });

  },
  getMaster(key) {
    var c = getCluster(key);
    if (!c) return null;
    return c.master;
  },
  addSlave(o, slave) {
    if (!slave) return;
    slave.forEach((c) => {
      addSlave(o, c);
    });
  },
  removeSlave(o, slave) {
    if (!slave) return;

    slave.forEach((c) => {
      removeSlave(o, c);
    });
  },
  getSlaves(key) {
    var c = getCluster(key);
    if (!c) return [];
    return c.slaves;
  }
}

export function KeepContainer({ on, children, onMounted, onUnmounted, onActivated, onUnactivated }) {
  let _broadcastEvent = null;
  let _life = false;
  const addEventable = () => {
    if (on) { //如果子类需要截获事件，那么给与事件的能力
      _broadcastEvent = DeviceEventEmitter.addListener('broadcastEvent', (arg) => { on(arg); });
    }
  }

  const removeEventable = () => {
    if (_broadcastEvent) {
      _broadcastEvent.remove();
      _broadcastEvent = null;
    }
  }


  const mounted = () => {
    if (_life) return;
    _life = true;
    addEventable();
    if (onMounted) onMounted();
  }

  const unmounted = () => {
    if (!_life) return;
    _life = false;
    removeEventable();
    if (onUnmounted) onUnmounted();
  }



  let _activated = false;
  const activated = () => {
    if (_activated) return;
    _activated = true;
    if (onActivated) onActivated();
  }

  const unactivated = () => {
    if (!_activated) return;
    _activated = false;
    if (onUnactivated) onUnactivated();
  }

  useEffect(() => {  //真实的创建和卸载
    mounted();
    return () => {
      unmounted();
    };
  }, []); //追加 []参数，表示只触发一次

  useKeepAliveEffect(() => {
    activated();
    return () => {
      unactivated();
    };
  });

  return children;
}

export class DeviceEventEmitter {

  static getListeners(type) {
    let l = DeviceEventEmitter.Listeners;
    if (!l[type]) {
      l[type] = [];
    }
    return l[type];
  }


  static addListener(type, action) {
    var listener = new DeviceEventEmitterListener(type, action)
    var l = DeviceEventEmitter.getListeners(type);
    l.push(listener);
    return listener;
  }

  static emit(type, arg) {
    var l = DeviceEventEmitter.getListeners(type);
    l.forEach((listener) => {
      listener.exec(arg);
    });
  }

}

DeviceEventEmitter.Listeners = {};

function DeviceEventEmitterListener(type, action) {
  var my = this;
  this._action = action;
  this.exec = function (arg) {
    this._action(arg);
  }

  this.remove = function () {
    var l = DeviceEventEmitter.getListeners(type);
    Util.remove(l, (t) => {
      return t == my;
    });
  }
}


export class UIComponent extends React.Component {

  constructor(props) {
    super(props);
    this.slave = this.mapSlave();
  }

  mapSlave() {
    let slave = this.slave || this.props.slave;
    if (!slave) return;
    if (Util.type(slave) == "string") {
      slave = [slave];
    }
    return slave.map((t) => mapClusterKey(t));
  }

  globalId() { //globalId是全局唯一的，但是每次加载组件，该编号由可能会改变
    if (this.componentId) return this.componentId;
    this.componentId = this.props.globalId || Util.getId();
    return this.componentId;
  }

  isUnmounted() {
    return this._unmounted;
  }

  addEventable() {
    if (this.on) { //如果子类需要截获事件，那么给与事件的能力
      this._broadcastEvent = DeviceEventEmitter.addListener('broadcastEvent', (arg) => { this.on(arg); });
    }
  }

  removeEventable() {
    if (this._broadcastEvent) {
      this._broadcastEvent.remove();
    }
  }

  componentDidMount() {

  }


  componentWillMount() {   //如果过两个页面都同时缓存，要确保cluster名称不同，否则会报错
    Cluster.addSlave(this, this.slave);
    this.addEventable();
  }

  componentWillUnmount() {
    this._unmounted = true;
    this.removeEventable();
    Cluster.closeMaster(this);
    Cluster.removeSlave(this, this.slave);
  }

  emit(source, arg) {
    UIComponent.emitBroadcast(source, arg);
  }

  static emitBroadcast(source, arg) {
    DeviceEventEmitter.emit('broadcastEvent', { source: source, ...arg }); //触发刷新UI的事件
  }
}

export function setPageTitle(title) {
  document.title = title ? `${title} - ${getConfig("name")}` : getConfig("name");
}

//在多页面下，page自身有可能被缓存，所以我们需要使用KeepContainer提供特殊事件来触发page原本的事件
// @bindLifecycle
export class Page extends UIComponent {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      loaded: this.needLoad() ? false : true,
      error: null
    }
    this.keepScroll = true;//默认情况下，当设置了keepId，那么滚动条也会被记忆和保持
    this.globalInstance = true; //默认情况下，每个page都会成为全局实例
    this.keepId = props.keepId || null;//默认不保持活力  keepId必须是全局唯一的，另外，每次加载同一个组件，该编号不会发生改变

    this.__params = this._getParams(); //节省性能
    this.initTracker();
  }

  initTracker() {
    let TrackerType = this._getTrackerType();
    if (TrackerType)
      this.tracker = new TrackerType({ params: this.getParams() });
    else if (this.getTracker) {
      let props = this.getTracker();
      this.tracker = new Tracker({ params: this.getParams(), ...props });
    }
  }

  _getTrackerType() {
    return this.getTrackerType ? this.getTrackerType() : null;
  }

  tryKeep(children) {
    if (this.keepId) {
      return (
        <KeepAlive name={`${this.keepId}`}>
          <KeepContainer on={(arg) => { let proxy = this.proxy(); if (proxy && proxy.on) proxy.on(arg); }}
            onActivated={() => { let proxy = this.proxy(); if (proxy && proxy.onActivated) proxy.onActivated(); }}
            onUnactivated={() => { let proxy = this.proxy(); if (proxy && proxy.onUnactivated) proxy.onUnactivated(); }}>
            {children}
          </KeepContainer>
        </KeepAlive>
      )
    }
    return children;
  }

  getCluster(name) {
    return this.keepId ? `${this.keepId}-${name}` : name;
  }

  go(name, params) {
    App.current.go(name, params);
  }

  back() {
    App.current.back();
  }

  _getParams() {
    let match = this.props.match;
    if (!match || !match.params) return {};
    let { params } = match.params;
    if (!params) return {};
    let code = unescape(Base64.decode(params));
    return JSON.parse(code);
  }

  getParams() { //节省开销
    return this.__params;
  }


  trackEnter() {
    if (this.tracker)
      this.tracker.enter();
  }

  trackLeave() {
  }


  needLoad() {
    return this.getLoadParas ? true : false;
  }

  _getLoadParas() {
    if (!this.getLoadParas) return null;
    return this.getLoadParas();
  }

  setGlobal() {
    //注意，执行基类方法之前就初始化实例
    if (this.globalInstance) {
      //注意由于生命周期的问题，page在即将卸载时，我们不能将Page.current=null;因为子组件还未卸载，有系列的相关操作需要用到Page.current
      //所以Page.current的更新是在有新的Page实例时替换
      //if(Page.current && !Page.current.isUnmounted()) throw new Error("同一时间只能有一个Page实例");
      //请自行确保同一时间只有一个page实例
      Page.current = this;
      Tester.fixture.set("page", this);
    }
  }

  proxy() { //当开启了缓存后，由于切换页面，会建立不同的page实例，但是程序员在写代码时，会用this.xxx调用一些方法和绑定dom事件，这就导致dom事件里的this还是用的已经卸载了的page，当页面渲染时，卸载了的page就会报错
    if (this.keepId) {
      return ProxyProvider.get(this.keepId);
    }
    return this;
  }

  setProxy() {
    if (this.keepId) {
      return ProxyProvider.set(this.keepId, this);  //将代理设置为当前有效的page
    }
  }

  ref(name,target) {
    if (Util.invalid(name)) return this._refs || this.refs;
    if (Util.type(name) === "string") {

      if(target){
        this._refs = this._refs ||{};
        this._refs[name] = target;
      }

      if (this._refs && this._refs[name]) return this._refs[name];
      return null;
    }

    let obj = name;
    this._refs = obj;
  }

  setTitle() {
    if (!this.globalInstance) return;
    setPageTitle(this.title);
  }

  onActivated() {   //页面被激活（包括缓存和非缓存的情况）
    this.setGlobal();
    this.setTitle();

    if (this.keepId) {
      App.current.registerKeep(this.keepId);
    }

    if (this.keepClear) {
      this.clearKeep();
    }

    this.trackEnter();

    if (this.keepScroll) {
      Scroller.load(this.keepId);
    }

    if (this.keepId) {
      let l = BAProvider.get(this.keepId);
      if (l) {
        l.forEach(c => {
          if (c.onActivated) c.onActivated();
        });
      }
    }
  }

  onUnactivated() {   //页面被取消激活
    this.trackLeave();
    if (this.keepScroll) {
      Scroller.save(this.keepId);
    }

    if (this.keepId) {
      //有缓存指示，那么记录状态
      StateProvider.save(this.keepId, this.state);
    }

    if (this.keepId) {
      let l = BAProvider.get(this.keepId);
      if (l) {
        l.forEach(c => {
          if (c.onUnactivated) c.onUnactivated();
        });
      }
    }

  }

  bindActivated(c) {
    if (!this.keepId) return;
    let l = BAProvider.getOrCreate(this.keepId);
    if (l.indexOf(c) > -1) return;
    l.push(c);
  }

  unbindActivated(c) {
    if (!this.keepId) return;
    //以下代码只是做个保险，让代码在逻辑上相呼应：有bindActivated也有unbindActivated，因为当页面销毁后，对应的BAProvider里的数据会先清空，再执行这里的代码，所以l是没有的
    let l = BAProvider.get(this.keepId);
    if (!l) return;
    let i = l.indexOf(c);
    if (i === -1) return;
    Util.removeAt(l, i);
  }

  componentWillMount() { //第一次进入页面
    super.componentWillMount();
    this.setGlobal();  //由于onActivated方法是子组件加载完毕后才触发的，这就导致了一个BUG：子组件要用Page.current 时，获取不了值，所以在这里componentWillMount事件中执行一次setGlobal
    this.setProxy();

    if (this.keepId &&
      StateProvider.contains(this.keepId)) { //当StateProvider.contains为true，表示该页面已经被缓存过
      let state = StateProvider.load(this.keepId);
      if (state)
        this.setState(state);
      return;
    }

    this._load(() => {

    });
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.keepId) return; //有缓存，通过缓存触发事件
    this.onActivated();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    if (this.keepId) return; //有缓存，通过缓存触发事件
    // super.componentWillUnmount();//不能调用该方法,因为onPageUnmounted已经调用了
    this.onUnactivated();
  }

  clearKeep() {
    App.current.clearKeep(this.keepClear, this.keepId);
  }

  _load(cb) {
    let p = this._getLoadParas();
    if (p) {
      let my = this;

      if (!p.success) p.success = (r) => { };
      let _success = p.success;
      p.before = () => {

      }
      p.complete = () => {

      }
      p.error = function (msg) {
        if (my.isUnmounted()) return; //防止数据没加载完用户就取消浏览，导致的bug
        my.setState({
          error: msg
        });
        if (cb) cb();
      }
      p.success = (r) => {
        if (my.isUnmounted()) return; //防止数据没加载完用户就取消浏览，导致的bug
        _success(r);

        my._complete(my);
        if (cb) cb();
      };
      Request(p);
    }
    else {
      this._complete(this);
      if (cb) cb();
    }
  }

  _complete(my) {
    if (my.isUnmounted()) return; //防止数据没加载完用户就取消浏览，导致的bug
    if (my.checkEmpty) {
      var msg = my.checkEmpty();
      if (msg === true) msg = "无此信息";
      if (msg) {
        my.setState({
          error: msg,
          loaded: true
        });
        return;
      }
    }

    my.setState({
      error: null,
      loaded: true
    });
  }

  reload(cb) {
    this._load(cb);
  }

  _renderLoading() {
    return this.renderLoading ? this.renderLoading() : this.renderDefaultLoading();
  }

  renderDefaultLoading() {
    return (
      <div className="animated slideInUpTiny animation-duration-3 w-100">
        <div className="row m-0" style={{ justifyContent: "center", alignItems: "center", height: "calc(100vh - 200px)" }}>
          <Alert className="alert-addon-card bg-info text-white shadow-lg">
            <span className="icon-addon alert-addon">
              <CircularProgress color="inherit" size={30} thickness={4} />
            </span>
            <span className="d-inline-block" style={{ fontSize: "1rem" }}>加载中</span>
          </Alert>
        </div>
      </div>
    );
  }

  renderError() {
    let { error } = this.state;
    var temp = error.split('\n');
    return (
      <div className="animated slideInUpTiny animation-duration-3 w-100">
        <div className="text-dark c-text-s1 c-text-sm-s2">
          {
            temp.map((item, i) => {
              return (
                <p key={i} className={`c-wrap`}>
                  {item}
                </p>
              )
            })
          }
        </div>
      </div>
    );
  }

  renderHeader() {
    return null;
  }

  renderBody() {
    return null;
  }

  tryScrollable(content) {
    return (
      this.scrollable ? (
        <Scrollbar>
          {content}
        </Scrollbar>
      ) : content
    );
  }


  renderPage() {
    //此处一定要用dom包裹（ <div className={`row no-gutters h-100`}>）,因为renderPage内的元素是直接进入了缓存区域的，不能用react组件，否则会有BUG
    return (
      <div className={`row no-gutters h-100`}>
        <div className="col-12">
          <div className="d-flex flex-column w-100  h-100">
            {this.renderHeader()}
            {this.tryScrollable(this.renderBody())}
          </div>
        </div>
      </div>
    );
  }

  _renderPage() {
    return this.tryKeep(this.renderPage());
  }

  render() {
    let { loaded, error } = this.state;
    if (error) return this.renderError();
    return loaded ? this._renderPage() : this._renderLoading()
  }
}


//实现getReloadParas，表示由外界传递数据初始化界面，实现getLoadParas，那么就是跟page一样，进入就访问服务器加载数据
export class Refreshable extends UIComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      loading: this.isImmediately(),
      data: props.data
    }
  }

  handleInit(r) {
    let { onInit } = this.props;
    if (onInit) onInit(r);
  }

  handleLoad(r) {
    let { onLoad } = this.props;
    if (onLoad) onLoad(r);
  }

  componentWillMount() { //第一次进入页面
    super.componentWillMount();
    if (this.isImmediately()) {
      this._load((r) => {  //只有立即加载的时候，才会触发第一次加载数据的init方法
        this.handleInit(r);
        this.handleLoad(r);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.get() !== nextProps.data) {
      this.set(nextProps.data, () => {
        this.refresh();
      });
    }
  }

  isImmediately() {  //是否立即加载
    return this.getLoadParas;
  }


  _load(cb) {
    let getParas = this.getLoadParas || this.getReloadParas;
    if (!getParas) {
      cb({});
      return;
    };

    let my = this, paras = getParas.apply(this);

    let processResult = paras.processResult;
    delete paras.processResult;

    Request.mute({
      success: (r) => {
        if (processResult) r = processResult(r) || r;
        my.setState({ data: r, loading: false });
        if (cb) cb(r);
      },
      ...paras
    });
  }

  get() {
    return this.state.data;
  }

  set(data, cb) {
    this.setState({ data }, () => {
      if (cb) cb();
    });
  }

  refresh(p) {
    let { local } = p || {};  //local:表示本地刷新，不锁屏
    if (local) {
      this.setState({
        loading: true
      }, () => {
        this._load((r) => {
          this.setState({
            loading: false
          }, () => { this.handleLoad(r); });
        });
      });
    }
    else {
      Backdrop.current.show();
      this._load((r) => {
        Backdrop.current.hide();
        this.handleLoad(r);
      });
    }
  }

  renderLoading() {
    let { loadingProps } = this;
    return (
      <div className="row no-gutters">
        <div className="col-12">
          <LoadingSlim className="c-mh15" size="sm" message="加载中" {...loadingProps} />
        </div>
      </div>
    );
  }


  renderWork() {
    if (!this.renderHeader) return this.renderBody();
    return (
      <div className={`row no-gutters h-100`}>
        <div className="col-12">
          <div className="d-flex flex-column w-100 h-100">
            {this.renderHeader()}
            {this.renderBody()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { loading } = this.state;
    return loading ? this.renderLoading() : this.renderWork()
  }

}

export const Scrollbar = React.forwardRef((props, ref) => {
  let ps = { ...props };
  let viewId = props.viewId;
  let autoHide = props.autoHide;
  let viewClassName = props.viewClassName || '';
  let horizontal = props.horizontal || false;
  let overflowY = props.overflowY;
  delete ps.viewId; delete ps.viewClassName; delete ps.horizontal; delete ps.overflowY;

  //useStyles修正容器内部元素边框不显示完整的问题
  const useStyles = makeStyles({
    root: props => ({
      paddingRight: 1,
      paddingBottom: 1,
      overflowY: `${overflowY} !important`,
    }),
  });

  let classes = useStyles();
  let horizontalStyle = horizontal ? { height: "7px", borderRadius: "5px" } : { display: "none" };
  if (autoHide !== false) ps.autoHide = true;
  return (
    <Scrollbars className="scrollbar"  {...ps} ref={ref}
      renderView={props => <div className={`${classes.root} ${viewClassName}`} {...props} id={viewId || ''} />}
      renderTrackHorizontal={props => <div {...props} style={horizontalStyle} className="track-horizontal" />} />
  );
});

Scrollbar.scrollLoadTimes = 0;
Scrollbar.load = (s, top) => {

  s.scrollTop(top);
  Scrollbar.scrollLoadTimes++;

  //效验是否改变
  let posTop = s.getScrollTop();
  let viewHeight = s.getClientHeight();
  if ((viewHeight >= posTop)  //已设置成功
    || (Scrollbar.scrollLoadTimes >= 10)) //超过尝试加载的最大次数
  {
    //满足了3个条件之一，那么删不再加载
    Scrollbar.scrollLoadTimes = 0;
  } else {
    setTimeout(() => {
      Scrollbar.load(s, top);
    }, 50);
  }
}


// export const XYScrollbar = React.forwardRef((props,ref) => <Scrollbars className="scrollbar"  {...props}  ref={ref}
//                             renderTrackVertical={props => <div {...props}  className="track-vertical"/>}
//                             renderTrackHorizontal={props => <div {...props}  className="track-horizontal"/>} />);


export default class SpringScrollbar extends React.Component {

  constructor(props, ...rest) {
    super(props, ...rest);
    this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
  }

  componentDidMount() {
    this.springSystem = new SpringSystem();
    this.spring = this.springSystem.createSpring();
    this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
  }

  componentWillUnmount() {
    this.springSystem.deregisterSpring(this.spring);
    this.springSystem.removeAllListeners();
    this.springSystem = undefined;
    this.spring.destroy();
    this.spring = undefined;
  }

  getScrollTop() {
    return this.refs.scrollbars.getScrollTop();
  }

  getScrollHeight() {
    return this.refs.scrollbars.getScrollHeight();
  }

  getHeight() {
    return this.refs.scrollbars.getHeight();
  }

  scrollTop(top) {
    const { scrollbars } = this.refs;
    const scrollTop = scrollbars.getScrollTop();
    //const scrollHeight = scrollbars.getScrollHeight();

    if (Util.type(top) === "object") {
      let target = top;
      let el = ReactDOM.findDOMNode(target);
      let targetRect = el.getBoundingClientRect();

      let owner = ReactDOM.findDOMNode(this);
      let ownerRect = owner.getBoundingClientRect();

      top = targetRect.y - ownerRect.y + scrollTop;
    }
    // const val = MathUtil.mapValueInRange(top, 0, scrollHeight, scrollHeight * 0.2, scrollHeight * 0.8);
    this.spring.setCurrentValue(scrollTop).setAtRest();
    this.spring.setEndValue(top);
  }

  handleSpringUpdate(spring) {
    const { scrollbars } = this.refs;
    const val = spring.getCurrentValue();
    scrollbars.scrollTop(val);
  }

  render() {
    return (
      <Scrollbar
        {...this.props}
        ref="scrollbars" />
    );
  }
}



export class View extends React.Component {

  constructor(props) {
    super(props);
  }

  getLineClass(className, line) {

    if (!line) return className;
    let lines = null;
    if (line.indexOf(',') == -1) lines = [line];
    else {
      lines = line.split(',');
    }

    lines.forEach((item) => {
      switch (item) {
        case "bottom": className += " bottomLine"; break;
        case "bottomTop5": className += " bottomLine line-top-5"; break;
        case "bottomTop10": className += " bottomLine line-top-10"; break;
        case "bottomTop15": className += " bottomLine line-top-15"; break;
        case "top": className += " topLine"; break;
        case "topTop5": className += " topLine line-top-5"; break;
        case "topBottom5": className += " topLine line-bottom-5"; break;
        case "topBottom10": className += " topLine line-bottom-10"; break;
        case "topBottom15": className += " topLine line-bottom-15"; break;
        case "bottom top":
        case "top bottom": className += " bottomLine topLine"; break;
      }
    });

    return className;
  }

  render() {
    let { style, children, onClick, onPress, className, scroll, line } = this.props;
    onClick = onClick || onPress;
    scroll = scroll ? { overflow: "auto" } : null;
    className = className || '';
    className = this.getLineClass(className, line);
    return (
      <div className={className} onClick={onClick ? (e) => { onClick(e); } : null} style={{ display: "flex", flexDirection: (style ? style.flexDirection : "column"), ...style, ...scroll }}>{children}</div>
    );
  }
}

function encodeHtml(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;").replace(/\'/g, "&#39;").replace(/\"/g, "&quot;");
};

function decodeHtml(s) {
  return s.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&nbsp;/g, " ").replace(/&#39;/g, "\'").replace(/&quot;/g, "\"");
};

export function toHtml(s, f) {
  if (f) {
    if (Util.type(f) == 'string') {
      var cls = f;
      f = function (c) {
        return ["<p class='", cls, "'>", encodeHtml(c), "</p>"].join('');
      }
    }

    s = s.replace(/\r\n/g, "\n");
    var l = s.split(/\n/g);
    for (var i = 0; i < l.length; i++) {
      l[i] = f(l[i]);
    }
    s = l.join('');
  }
  else {
    s = encodeHtml(s);
    s = s.replace(/\r\n/g, "\n");
    s = s.replace(/\n/g, "<br />");
  }
  return s;
}


const _internalColors = ['default', "primary", "secondary", "success", "danger", "warning", "info", "light", "dark", "blue", "white"];
const _extensionColors = ['cyan', 'teal', 'amber', 'orange', 'deep-orange', 'red', 'pink', 'light-blue', 'indigo', 'lime', 'light-green', 'purple', 'deep-purple', 'green', 'grey', 'blue-grey', 'black', 'light-grey', 'disabled'];
const _metronicColors = ['m-text-muted', 'm-text-primary', 'm-text-success', 'm-text-danger', 'm-text-dark-75', 'm-text-dark-50',
  'm-bg-primary', 'm-bg-success', 'm-bg-danger', 'm-bg-warning', 'm-bg-light', 'm-bg-muted', 'm-bg-dark-75',
  'm-bg-light-primary', 'm-bg-light-success', 'm-bg-light-danger', 'm-bg-light-dark-75', 'm-bg-light-dark-50', 'm-bg-light-info']; //以后补全
export function fillThemeColor(props, color, ignoreProp) { //ignoreProp是否忽略为属性设置color,就是填充的背景色，如有其他需求，请用getThemeColor
  if (!color) return props;
  if (_internalColors.indexOf(color) > -1) {
    if (ignoreProp) {
      props.className = `bg-${color} ${props.className}`;
    }
    else
      props.color = color;
    return props;
  }

  if (_extensionColors.indexOf(color) > -1) {
    props.className = `c-bg-${color} ${props.className}`;
    return props;
  }

  if (_metronicColors.indexOf(color) > -1) {
    props.className = `${color} ${props.className}`;
    return props;
  }

  //编码色
  if (testCodedColor(color) == false) // 不是正确的编码色格式，则默认为灰色
    color = theme.color["grey-system"];
  props.style = { ...props.style, backgroundColor: color };
  return props;

}

// 检查编码色的格式是否正确
function testCodedColor(color) {
  var re1 = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i
  var re2 = /^rgb\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\)$/i
  var re3 = /^rgba\(([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,([0-9]|[0-9][0-9]|25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9])\,(1|1.0|0.[0-9])\)$/i
  return re2.test(color) || re1.test(color) || re3.test(color);
}

export function Empty({ text, className, textClassName, align }) {
  return <div className={`d-flex flex-column justify-content-center align-items-${align} c-text-grey p-4 ${textClassName} ${className}`}>
    {text || '暂无信息'}
  </div>
}

Empty.defaultProps = {
  className: '',
  textClassName: 'c-text-s3',
  align: "center"
}


export function EmptySlim({ className, label, gap }) {
  return <p className={`my-${gap} m-text-muted ${className}`}>{label}</p>
}

EmptySlim.defaultProps = {
  gap: 3,
  label: "暂无信息",
  className: 'c-text-s2'
}


export function getThemeColor(name, type) {
  if (!type) type = "text";

  if (type == 'value') {
    return theme.color[name] || name;
  }

  if (_internalColors.indexOf(name) > -1) {
    return `${type}-${name}`;
  }

  if (_extensionColors.indexOf(name) > -1) {
    return `c-${type}-${name}`;
  }
  if (_metronicColors.indexOf(name) > -1) {
    return name;
  }
  return '';
}

export const theme = {
  color: {
    default: "#252525",
    blue: '#2196F3',
    indigo: '#6610f2',
    purple: '#6f42c1',
    pink: '#e83e8c',
    red: '#dc3545',
    orange: '#fd7e14',
    yellow: '#ffc107',
    green: '#28a745',
    teal: '#20c997',
    cyan: '#17a2b8',
    white: '#fff',
    gray: '#6c757d',
    primary: '#3f51b5',
    secondary: '#ff4081',
    success: '#28a745',
    info: '#00bcd4',
    warning: '#ffb822',
    danger: '#dc3545',
    light: '#f8f9fa',
    dark: '#343a40',
    indigo: "#3f51b5",
    secondaryDark: '#ff4081',
    amber: '#ffc107',
    favorite: "#ff3d47",
    line: "#e6e6e6",
    'grey-system': "#bdbdbd",
    'bar-green': "#9fdabf",
    'r-green': "rgb(0, 196, 159)",
    'r-orange': "rgb(255, 128, 66)",
    'light-grey': '#ccc',
    'light-blue': '#03a9f4',
    'light-primary': '#e4e7f6',
    'm-success': '#0abb87 ',
    'm-warning': '#ffb822 ',
    'm-danger': '#fd397a ',
    'm-info': '#5578eb ',
    'm-primary': '#5867dd ',
    'm-brand': '#5d78ff ',
    'm-dark': '#282a3c ',
    'm-light': '#f3f6f9',
    'm-muted': '#b5b5c3',
    'm-text-muted': '#b5b5c3',
    'm-text-dark75': '#464e5f',
    'm-text-dark-75': '#464e5f',
    'm-text-dark50': '#80808f',
    'm-text-dark-50': '#80808f',
    'm-bg-light-info': '#eee5ff',
    'm-bg-light-primary': '#e1e9ff'
  },
  font: {
    s1: {
      fontSize: "0.875rem",
      lineHeight: "1.75rem"
    },
    s1d5: {
      fontSize: "0.92rem",
      lineHeight: "1.6rem"
    },
    s2: {
      fontSize: "0.98rem",
      lineHeight: "1.96rem"
    },
    s3: {
      fontSize: "1.1rem",
      lineHeight: "2.2rem"
    }
  }
}


export function getThemeColorValue(name) {
  return name ? theme.color[name] : null;
}

const multicolor = ["blue", "purple", "pink", "red", "orange", "yellow", "green", "teal", "cyan", "primary", "info", "light-blue"];

//循环获取颜色
export function getLoopMulticolorValue(index, colors) {
  colors = colors || multicolor;
  let i = index % colors.length;
  return getThemeColorValue(colors[i]);
}

//数组洗牌算法
function shuffleArray(array) {
  var m = array.length,
    t, i;
  while (m) {
    i = Math.floor(Math.random() * m--);
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }
  return array;
}

//随机获取颜色数组
export function getRandomMulticolors() {
  return shuffleArray(multicolor.slice());
}

export function usingRandomMulticolorValue(action, max) {
  var colors = getRandomMulticolors();
  for (var i = 0; i < max; i++) {
    var color = getLoopMulticolorValue(i, colors);
    action(color, i);
  }
}


export function getFontSize(name) {
  return name ? theme.font[name].fontSize : null
}